<template>
    <div id="wrapper" class="bg-light d-flex flex-column align-items-center">
        <div id="form-container" class="col-6 bg-whte p-5 rounded">
            <div class="row">
                <div class="col">
                    <div id="demo">
                        <fontawesome-picker v-model="icon"></fontawesome-picker>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FontawesomePicker from './FontawesomePicker';

export default {
    name: 'App',
    components: {
        'fontawesome-picker': FontawesomePicker 
    },
    data: function () {
        return {
            icon: "" };

    } 
};
</script>
